import { FirestoreDataConverter } from '@angular/fire/firestore';
import { UnitTypeEnum } from "../enums/unit-type.enum";

/**
 * Model for Commerce Product Variation (Used for Commerce)
 */
export class CommercePriceGrid {
  id: string;
  variationId: string;
  name: string;
  prices: { from: number, price: number }[];
  quantityMin: number | null;
  quantityMax: number | null;
  fixedCost: number | null;
  customers: string[];
  unit: UnitTypeEnum;
  minPrice: number;

  constructor(data?: Partial<CommercePriceGrid>) {
    this.id = data?.id ?? '';
    this.variationId = data?.variationId ?? '';
    this.name = data?.name ?? '';
    this.quantityMin = data?.quantityMin ?? 0;
    this.quantityMax = data?.quantityMax ?? 0;
    this.fixedCost = data?.fixedCost ?? 0;
    this.prices = data?.prices ?? [];
    this.customers = data?.customers ?? [];
    this.unit = data?.unit ?? UnitTypeEnum.Unit;
    this.minPrice = data?.minPrice ?? 0;
  }

  /**
   * Converter used to convert a shipment from firebase
   */
  static converter: FirestoreDataConverter<CommercePriceGrid> = {
    toFirestore: (price: CommercePriceGrid) => {
      return {
        id: price.id,
        variationId: price.variationId,
        name: price.name,
        prices: price.prices,
        customers: price.customers,
        unit: price.unit,
        quantityMin: Number.isInteger(price.quantityMin) ? Number(price.quantityMin) : 0,
        quantityMax: Number.isInteger(price.quantityMax) ? Number(price.quantityMax) : 0,
        fixedCost: Number.isNaN(price.fixedCost) ? 0 : Number(price.fixedCost),
        minPrice: Number.isNaN(price.minPrice) ? 0 : Number(price.minPrice),
      };
    },
    fromFirestore: (snapshot, options) => {
      const data = snapshot.data(options);
      return new CommercePriceGrid({
        ...data,
        id: snapshot.id,
      });
    }
  };
}
